import script from "./BuyerGuidelines.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyerGuidelines.vue?vue&type=script&setup=true&lang=js"

import "./BuyerGuidelines.vue?vue&type=style&index=0&id=43040776&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43040776"]])

export default __exports__